export default "__VITE_PUBLIC_ASSET__43706ada__"